import { render } from "./ReplacedCases.vue?vue&type=template&id=3a8ced46"
import script from "./ReplacedCases.vue?vue&type=script&lang=js"
export * from "./ReplacedCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/ReplacedCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a8ced46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a8ced46', __exports__)) {
    console.log('reload')
    api.reload('3a8ced46', __exports__)
  }
  
  module.hot.accept("./ReplacedCases.vue?vue&type=template&id=3a8ced46", () => {
    console.log('re-render')
    api.rerender('3a8ced46', render)
  })

}


export default __exports__